module.exports = __webpack_public_path__ + "static/media/producer-signal-icon.c066662d.svg";